/**
 * Definición de roles del sistema
 */
export const ROLES = {
  ADMINISTRADOR: 1,
  ADMINISTRATIVO: 2,
  AUDITOR: 3,
  COORDINADOR: 4
};

/**
 * Nombres de roles para display
 */
export const ROLE_NAMES = {
  [ROLES.ADMINISTRADOR]: 'Administrador',
  [ROLES.ADMINISTRATIVO]: 'Administrativo',
  [ROLES.AUDITOR]: 'Auditor',
  [ROLES.COORDINADOR]: 'Coordinador'
};

/**
 * Descripción de roles
 */
export const ROLE_DESCRIPTIONS = {
  [ROLES.ADMINISTRADOR]: 'Acceso completo al sistema',
  [ROLES.ADMINISTRATIVO]: 'Gestión de novedades y empleados',
  [ROLES.AUDITOR]: 'Solo lectura de información',
  [ROLES.COORDINADOR]: 'Gestión de novedades y empleados'
};

export default ROLES;
